import React, { useEffect } from 'react';
import './Alert.css';

function Alert({ type, message, onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`alert alert-${type}`}>
      <div className="alert-content">
        <span className="alert-icon">
          {type === 'success' && '✓'}
          {type === 'warning' && '⚠'}
          {type === 'error' && '✕'}
        </span>
        <span className="alert-message">{message}</span>
      </div>
      <button className="alert-close" onClick={onClose}>×</button>
    </div>
  );
}

export default Alert;
